import { createSlotFill } from '@wordpress/components';

const { Fill: SidebarToggleFill, Slot: SidebarToggleSlot } =
	createSlotFill( 'SidebarToggle' );

export { SidebarToggleFill, SidebarToggleSlot };
